import { makeAutoObservable } from 'mobx';
import { Activity } from '../models/activity';
import { HistoryViewItemLevel } from '../models/history';
import { imageData } from '../models/imageData';
import { FileUploadInterface } from '../models/Profile';
import { store } from './store';

interface CameraDataRegister {
  id: string;
  fileName: string;
  url: string;
}

interface mediaAsset {
  editworkflow: string;
  modal: boolean;
  openStart: boolean;
  openHold: boolean;
  resolveValueSelected: boolean;
  taskname: string;
  link: string;
  // Microtagging menu screen position
  XscreenPosition: number;
  YscreenPosition: number;
  // redirect from alerts page to media asset page \
  redirectOpenReject: boolean;
  redirectOpenResolved: boolean;
  alertsResolveorRejectModalOpen: boolean;
  // close or show  Media Asset title when video is played
  showMediaAssetTitle: boolean;
  // opens L3 stepper in media assets
  openL3MediaAssetStepper: boolean;
  // delete user modal
  deleteUserModalOpen: boolean;
  userDetails: {
    id: string;
    displayName: string;
  };
  // edit User
  editmodal: boolean;
  userEditId: string | undefined;
  // edit profile
  editProfile: boolean;
  //camera in task
  openCameraModal: boolean;
  camImageBase64: Blob[];
  camImageUrl: CameraDataRegister[];
  // history
  activityUpdated: string | null;
  devicehistoryCreated: string | null;
  shelfhistoryCreated: string | null;
  departmenthistoryCreated: string | null;
  customerhistoryCreated: string | null;
  worklevelhistoryCreated: string | null;
  clickedComplete: string | null;
  clickedHold: string | null;
  clickedReject: string | null;
  clickedRework: string | null;
  clickedResume: string | null;
  clickedStart: string | null;
  adduser: string | null;
  fileadded: string | null;
  verifyChildTabPane: HistoryViewItemLevel[];
  userSelectedHistoryId: string;
  updateactivity: string;
  imageuploadurl: imageData[];
  imageupload: string;
  updateActivityy: boolean;
  rejectValue: string;
  resolveValue: string;
  tasknamemsg: string;
  subtaskmsg: string;
  attachCommunicationField: string;
  useridmobileassignuser: string;
  assignuserId: string;

  voiceresponse: FileUploadInterface[];
  assignusercomment: string;
  assetformhistoryValue: string;
  assetformhistorydefaultValue: string;
  assetformhistoryplaceholder: string;
  taskformmodalhistoryinputdefaultvalue: string;
  taskformmodalhistoryinputplaceholder: string;
  taskformmodalhistoryinputvalue: string;
  taskformmodalhistoryoptionsdefaultvalue: string;
  taskformmodalhistoryoptionsplaceholder: string;
  taskformmodalhistoryoptionsvalue: string;
  assetformhistoryInputValue: string;
  assetformhistoryInputdefaultValue: string;
  assetformhistoryInputplaceholder: string;
  metadataHistoryPlaceholder: string;
  metadataHistoryDefaultValue: string;
  metadataHistoryValue: string;
  metaDataOptionHistoryPlaceholder: string;
  metadataOptionHistoryDefaultValue: string;
  metadataOptionHistoryValue: string;
  historyCountData: number;
  openSectionSingle: boolean;
  openSectionMultiple: boolean;
  openSectionExiste: boolean;
  openReelsCreation: boolean;
  openCutListCreation: boolean;
  checkingValue: string;
  finalDefaultValue: string;
  value: string;
  strop: string;
  valueTextop: string;
  defaultValueTextop: string;
  stropDd: string;
  valueTextopDd: string;
  defaultValueTextopDd: string;
  workingValue: string;
  wfdmdd: any;
  wfdmddId: any;
  wfmdev: any;
  allarrwfmd: any[];
  dummyDynamicMetaData: any;
  wfdmtemplateId: any;
  wfelemValue: string;
  selectedOptionssasd: any;
  selectedEnableByDefault: any;
  selectedReadOnly: any;
  selectedOptionPhotos: any[];
  selectedOptionFiles: any[];
  refreshSectionMain: boolean;
  wfdmddLabel: string;
  isViewPageCreaterLoading: boolean;
  isViewPageCreaterModalOpen: boolean;
  subtaskCompleteDetails: {
    isLoading: boolean;
    id: string;
  };
}
const initialState = {
  modal: false,
  ///open editworkflow on adh
  editworkflow: 'cancel',
  resolveValueSelected: false,
  taskname: '',
  ///
  link: '',
  // Microtagging menu screen position
  XscreenPosition: 0,
  YscreenPosition: 0,
  // redirect from alerts page to media asset page \
  redirectOpenReject: false,
  redirectOpenResolved: false,
  //open alerts table modal ResolveorReject
  alertsResolveorRejectModalOpen: false,
  // close  Media Asset title when video is played
  showMediaAssetTitle: true,
  // opens L3 stepper in media assets
  openL3MediaAssetStepper: false,
  // delete user modal
  deleteUserModalOpen: false,
  userDetails: {
    id: '',
    displayName: '',
  },
  // edit user
  editmodal: false,
  userEditId: undefined,
  // edit profile
  editProfile: false,
  //camera in tasks
  openCameraModal: false,
  camImageBase64: [],
  camImageUrl: [],
  // history
  activityUpdated: '',
  devicehistoryCreated: '',
  shelfhistoryCreated: '',
  departmenthistoryCreated: '',
  customerhistoryCreated: '',
  worklevelhistoryCreated: '',
  clickedComplete: '',
  clickedHold: '',
  clickedReject: '',
  clickedRework: '',
  clickedResume: '',
  clickedStart: '',
  verifyChildTabPane: [],
  userSelectedHistoryId: '',
  adduser: '',
  fileadded: '',
  updateactivity: '',
  imageuploadurl: [],
  updateActivityy: false,
  imageupload: '',
  rejectValue: '',
  resolveValue: '',
  tasknamemsg: '',
  subtaskmsg: '',
  openStart: false,
  openHold: false,
  attachCommunicationField: '',
  useridmobileassignuser: '',
  assignuserId: '',
  voiceresponse: [],
  assignusercomment: '',
  assetformhistoryValue: '',
  assetformhistorydefaultValue: '',
  assetformhistoryplaceholder: '',
  taskformmodalhistoryinputdefaultvalue: '',
  taskformmodalhistoryinputplaceholder: '',
  taskformmodalhistoryinputvalue: '',
  taskformmodalhistoryoptionsdefaultvalue: '',
  taskformmodalhistoryoptionsplaceholder: '',
  taskformmodalhistoryoptionsvalue: '',
  assetformhistoryInputValue: '',
  assetformhistoryInputdefaultValue: '',
  assetformhistoryInputplaceholder: '',
  metadataHistoryPlaceholder: '',
  metadataHistoryDefaultValue: '',
  metadataHistoryValue: '',
  metaDataOptionHistoryPlaceholder: '',
  metadataOptionHistoryDefaultValue: '',
  metadataOptionHistoryValue: '',
  historyCountData: 0,
  openSectionSingle: false,
  openSectionMultiple: false,
  openSectionExiste: false,
  checkingValue: '',
  finalDefaultValue: '',
  value: '',
  strop: '',
  valueTextop: '',
  defaultValueTextop: '',
  stropDd: '',
  valueTextopDd: '',
  defaultValueTextopDd: '',
  workingValue: '',
  wfdmdd: '',
  wfdmddId: '',
  wfmdev: '',
  allarrwfmd: [],
  dummyDynamicMetaData: '',
  wfdmtemplateId: '',
  wfelemValue: '',
  selectedOptionssasd: [],
  selectedEnableByDefault: false,
  selectedReadOnly: false,
  selectedOptionPhotos: [],
  selectedOptionFiles: [],
  refreshSectionMain: false,
  wfdmddLabel: '',

  // -------------- view page create order --------------------- //
  isViewPageCreaterLoading: false,
  isViewPageCreaterModalOpen: false,
  subtaskCompleteDetails: {
    isLoading: false,
    id: '',
  },
  openReelsCreation: false,
  openCutListCreation: false,
};
export default class mediaAssetStore {
  static mediaAsset: any;
  constructor() {
    makeAutoObservable(this);
  }
  mediaAsset: mediaAsset = initialState;
  mediaSaveLoader = false;
  //
  editworkflowopen = (data: string) => {
    this.mediaAsset.editworkflow = data;
  };
  //tasks
  setOpenCameraModal = (e: boolean) => {
    this.mediaAsset.openCameraModal = e;
  };
  setRegisterUrlResponse = (e: CameraDataRegister[]) => {
    this.mediaAsset.camImageUrl = e;
  };
  setVoiceRecorder = (e: FileUploadInterface[]) => {
    this.mediaAsset.voiceresponse = e;
  };
  setcamImageBase64 = (e: Blob[]) => {
    this.mediaAsset.camImageBase64 = e;
  };

  // setWorkLevelMaster=(e:Template)=>{
  //   this.mediaAsset
  //   this.mediaAsset
  //   this.mediaAsset
  //   this.mediaAsset
  //   this.mediaAsset
  //   this.mediaAsset
  // }
  openLink = (e: string) => {
    this.mediaAsset.link = e;
  };
  //  opens modal for media asset when resolve button pressed
  openMediaAssetResolveModal = (e: boolean) => {
    //  opens modal for media asset when resolve button pressed
    this.mediaAsset.resolveValueSelected = e;
  };
  openMediaAssetRejectModal = (e: boolean) => {
    this.mediaAsset.alertsResolveorRejectModalOpen = true;
  };
  // Microtagging menu screen position
  setScreenPositionMicroTagging = (e: number, f: number) => {
    this.mediaAsset.XscreenPosition = e;
    this.mediaAsset.YscreenPosition = f;
  };
  // redirect from alerts page to media asset page and opens modal
  setRedirectOpenRejectModal = (e: boolean) => {
    this.mediaAsset.redirectOpenReject = e;
  };
  setRedirectOpenResolvedModal = (e: boolean) => {
    this.mediaAsset.redirectOpenResolved = e;
  };
  //opens modal at Media AssetPage
  simpleModalOpen = (e: boolean) => {
    this.mediaAsset.modal = e;
  };
  //opens workflow task name on media Assets
  setClickedTaskName = (e: string) => {
    this.mediaAsset.taskname = e;
  };
  // close  Media Asset title when video is played
  setShowHideMediaAssetTitle = () => {
    this.mediaAsset.showMediaAssetTitle = false;
  };
  // delete user modal
  openDeleteUserModal = (e: boolean, f: string, g: string) => {
    this.mediaAsset.deleteUserModalOpen = e;

    this.mediaAsset.userDetails = {
      id: f,
      displayName: g,
    };
  };
  // edit User
  editModalOpen = (e: boolean, f: string | undefined) => {
    this.mediaAsset.editmodal = e;
    this.mediaAsset.userEditId = f;
  };
  // profile
  editProfileModal = (e: boolean) => {
    this.mediaAsset.editProfile = e;
  };

  //history
  setActivityUpdated = (e: string | null) => {
    this.mediaAsset.activityUpdated = e;
  };
  // setVaultEditHistoryCreated=(e:string|null)=>{
  //   this.mediaAsset.vaulthistoryCreated=e
  // }
  setDeviceCreateHistoryCreated = (e: string | null) => {
    this.mediaAsset.devicehistoryCreated = e;
  };
  setDeviceEditHistoryCreated = (e: string | null) => {
    this.mediaAsset.devicehistoryCreated = e;
  };
  setShelfCreateHistoryCreated = (e: string | null) => {
    this.mediaAsset.shelfhistoryCreated = e;
  };
  setShelfEditHistoryCreated = (e: string | null) => {
    this.mediaAsset.shelfhistoryCreated = e;
  };
  setDepartmentCreateHistoryCreated = (e: string | null) => {
    this.mediaAsset.departmenthistoryCreated = e;
  };
  setDepartmentEditHistoryCreated = (e: string | null) => {
    this.mediaAsset.departmenthistoryCreated = e;
  };
  setCustomerCreateHistoryCreated = (e: string | null) => {
    this.mediaAsset.customerhistoryCreated = e;
  };
  setCustomerEditHistoryCreated = (e: string | null) => {
    this.mediaAsset.customerhistoryCreated = e;
  };
  setWorkLevelCreateHistoryCreated = (e: string | null) => {
    this.mediaAsset.worklevelhistoryCreated = e;
  };
  setWorkLevelEditHistoryCreated = (e: string | null) => {
    this.mediaAsset.worklevelhistoryCreated = e;
  };
  setClickedComplete = (e: string) => {
    this.mediaAsset.clickedComplete = e;
  };
  setClickedHold = (e: string) => {
    this.mediaAsset.clickedHold = e;
  };
  setClickedReject = (e: string) => {
    this.mediaAsset.clickedReject = e;
  };
  setClickedRework = (e: string) => {
    this.mediaAsset.clickedRework = e;
  };
  setClickedResume = (e: string) => {
    this.mediaAsset.clickedResume = e;
  };
  setStart = (e: string) => {
    this.mediaAsset.clickedStart = e;
  };
  setAddUser = (e: string) => {
    this.mediaAsset.adduser = e;
  };
  setFileUpdated = (e: string) => {
    this.mediaAsset.fileadded = e;
  };
  showUserHistoryId = (e: string) => {
    this.mediaAsset.userSelectedHistoryId = e;
  };
  updatedActivity = (e: string) => {
    this.mediaAsset.updateactivity = e;
  };
  setWorkLevelHistory = (e: Activity) => {
    this.mediaAsset.userSelectedHistoryId = e.title;
  };
  setAssetFile = (e: imageData[]) => {
    this.mediaAsset.imageuploadurl = e;
  };
  setFile = (e: string) => {
    this.mediaAsset.imageupload = e;
  };
  setRejectComments = (e: string) => {
    this.mediaAsset.rejectValue = e;
  };
  setResolveComments = (e: string) => {
    this.mediaAsset.resolveValue = e;
  };
  setAttachCommunicationField = (e: string) => {
    this.mediaAsset.attachCommunicationField = e;
  };

  //  setHistoryCount=async()=>{
  //   const responsenumber=await agent.ag
  //   historyCountData:0
  //  }
  setOpenSectionsSingle = (e: boolean) => {
    this.mediaAsset.openSectionSingle = e;
    store.dashboardStore.dashboard.CreateOrderTemplate = undefined;
    store.TemplateStore.selectedTemplate = undefined;
  };
  setOpenSectionsMultiple = (e: boolean) => {
    this.mediaAsset.openSectionMultiple = e;
    store.dashboardStore.dashboard.CreateOrderTemplate = undefined;
    store.TemplateStore.selectedTemplate = undefined;
  };
  setOpenSectionsExiste = (e: boolean) => {
    this.mediaAsset.openSectionExiste = e;
  };
  setOpenReelsCreation = (e: boolean) => {
    this.mediaAsset.openReelsCreation = e;
  };
  setOpenCutListCreation = (e: boolean) => {
    this.mediaAsset.openCutListCreation = e;
  };
  resetMediaAsset = () => {
    this.mediaAsset = initialState;
  };
}
